// extracted by mini-css-extract-plugin
module.exports = {"Name":"Stat_Name__1eYsR","Value":"Stat_Value__28Oeo"};